<template>

  <DashboardLayout :menu-items="dashboardMenu">
    <div class="my-dashboard d-lg-none d-sm-block">
      <div class="row">
        <b-icon-person class="profile-fixed text-right rounded rounded-circle"/>
        <span class="mt-4 mr-2">   {{
            `${$store.getters['User/getProfile'].name} ${$store.getters['User/getProfile'].last_name}`
          }}</span>
        <!--    todo: add notification and wallet     -->
        <!--        <div class="col-8 col-sm-10 col-lg-9 pt-3 ml-0 inventory text-left">

                  <span>
                                   <b-icon class="bell-big text-right" icon="bell" href="#"></b-icon>
                                     <span class='badge badge-warning' id='lblCartCount'> 1 </span>
                                 </span>
                  موجودی:۲۰۰۰ تومان
                </div>-->
      </div>
    </div>
    <div class="text-dashboard  w-100 h-auto">
      <h3> دسترسی سریع:</h3>

      <div class="row">


        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'Profile'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="emoji-sunglasses"></b-icon>
              </b-card-title>
              <b-card-text>
                پروفایل
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'Home'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="house"></b-icon>
              </b-card-title>
              <b-card-text>
                بازگشت به سایت
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <b-col lg="4" class="mt-3">
          <router-link class="text-decoration-none" :to="{name:'Address'}">

            <b-card class="text-center">
              <b-card-title>
                <b-icon icon="signpost2-fill"></b-icon>
              </b-card-title>
              <b-card-text>
                آدرس های من
              </b-card-text>
            </b-card>
          </router-link>
        </b-col>

        <b-container class="mt-5">
          <Orders/>
        </b-container>

        <b-container class="mt-5">
          <UserCourse/>
        </b-container>

      </div>

    </div>

  </DashboardLayout>
</template>

<script>
import {mapActions} from 'vuex'
import {dashboardMenu} from '../../routes/DashboardRoutes'
import DashboardLayout from '../../components/dashboard/Layout'
import Orders from '../dashboard/orders'
import UserCourse from "../../components/dashboard/Course/UserCourse";

export default {
  name: "Dashboard",
  components: {DashboardLayout, Orders, UserCourse,},
  data() {
    return {
      dashboardMenu
    }
  },
  methods: {
    ...mapActions({
      logout: "Authentication/logout"
    })
  }

};
</script>

<style scoped>
.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
  padding: 10px;
}

.inventory {
  font-size: 80%;
}

.my-dashboard {
  width: 100%;
  height: 70px;
  background: white;
  border-radius: 5px;

}

.profile-fixed {
  width: 50px;
  height: 50px;
  margin-right: 50px;
  margin-top: 12px;
}

.text-dashboard {
  width: 95%;
  height: auto;
  background: #fafbf8;
  margin: auto;
  border-radius: 5px;
}

#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px;
  margin-top: 0px;
}

.bell-big {
  width: 30px;
  height: 20px;
}


</style>